import { PrizmLanguageInputLayoutDateTime } from '../../interfaces';

export const PRIZM_ENGLISH_INPUT_LAYOUT_DATE_TIME: PrizmLanguageInputLayoutDateTime = {
  inputLayoutDateTime: {
    wrongFormat: 'Incorrect data format',
  },
};
